import { useForm, Controller } from 'react-hook-form';
import {
  Button,
  TextField,
  CircularProgress,
  Typography,
  Snackbar,
  Alert,
  Tooltip,
  IconButton,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Box,
  Paper,
  InputAdornment,
  Stack,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  stepConnectorClasses,
  styled
} from '@mui/material';
import {
  Info as InfoIcon,
  Home as HomeIcon,
  Person as PersonIcon,
  SwapHoriz as SwapHorizIcon,
  CalendarToday as CalendarIcon,
  Pets as PetsIcon,
  Apartment as ApartmentIcon,
  Map as MapIcon,
  LocationCity as LocationCityIcon,
  Notes as NotesIcon,
  Category as CategoryIcon,
  ArrowBack as ArrowBackIcon,
  CheckCircle as CheckCircleIcon,
  PlayCircle as PlayCircleIcon,
  Cancel as CancelIcon,
} from '@mui/icons-material';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import Container from '../../../components/layout/Container';
import Fieldset from '../../../components/Form/Fieldset';
import Row from '../../../components/Form/Row';
import Form from '../../../components/Form/Form';
import AppBarComponent from '../../../components/AppBarComponent';
import ButtonArea from '../../../components/Form/ButtonArea';
import EuroInput from '../../../components/inputs/EuroInput';

// Estilos personalizados para o Stepper
const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        'linear-gradient( 95deg, #1976d2 0%, #1976d2 50%, #1976d2 100%)',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        'linear-gradient( 95deg, #4caf50 0%, #4caf50 50%, #4caf50 100%)',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor:
      theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
  zIndex: 1,
  color: '#fff',
  width: 50,
  height: 50,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  ...(ownerState.active && {
    backgroundImage:
      'linear-gradient( 136deg, #1976d2 0%, #1976d2 50%, #1976d2 100%)',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  }),
  ...(ownerState.completed && {
    backgroundImage:
      'linear-gradient( 136deg, #4caf50 0%, #4caf50 50%, #4caf50 100%)',
  }),
}));

function ColorlibStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: <PlayCircleIcon />,
    2: <SwapHorizIcon />,
    3: <CheckCircleIcon />,
  };

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

// Estilos
const ButtonAreaStyled = styled(ButtonArea)`
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #e0e0e0;
`;

const StyledFieldset = styled(Fieldset)`
  background-color: #ffffff;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 32px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  border: 1px solid #e0e0e0;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);
  }
`;

const SectionTitle = styled(Typography)`
  color: #424242;
  font-weight: 600;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1.1rem;
`;

const FormTitle = styled(Typography)`
  color: #1976d2;
  font-weight: 600;
  margin-bottom: 32px;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  gap: 12px;
`;

const StatusContainer = styled(Box)`
  margin: 24px 0;
  padding: 16px;
  background-color: #f5f5f5;
  border-radius: 12px;
`;

const propertyTypes = [
  { value: 'APARTAMENTO', label: 'Apartamento' },
  { value: 'CASA', label: 'Casa' },
  { value: 'COMERCIAL', label: 'Comercial' },
  { value: 'TERRENO', label: 'Terreno' }
];

const categories = [
  { value: 'T1', label: 'T1' },
  { value: 'T2', label: 'T2' },
  { value: 'T3', label: 'T3' },
  { value: 'T4+', label: 'T4+' }
];

const statusSteps = [
  { label: 'Criada', value: 'created' },
  { label: 'Em Andamento', value: 'in_progress' },
  { label: 'Concluída', value: 'concluded' },
    { label: 'Cancelada', value: 'canceled' } // Adicione esta linha

];

const buildApiUrl = (endpoint) => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL || process.env.VITE_API_BASE_URL;
  if (!baseUrl) {
    console.error('API_BASE_URL não está definido no arquivo .env');
    return endpoint;
  }
  const normalizedBase = baseUrl.replace(/\/+$/, '') + '/';
  return new URL(endpoint, normalizedBase).toString();
};

export default function EditarRealocacaoPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    control,
    handleSubmit,
    formState: { isSubmitting, isValid, isDirty },
    reset,
    watch,
    setValue,
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      titleRelocation: '',
      status: '',
      cost: '',
      originAddress: '',
      originCity: '',
      originNeighborhood: '',
      originState: '',
      destinationAddress: '',
      destinationCity: '',
      destinationNeighborhood: '',
      destinationState: '',
      propertyType: '',
      category: '',
      petFriendly: false,
      observation: '',
      startDate: '',
      expectedEndDate: ''
    }
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [isLoading, setIsLoading] = useState(true);
  const [editable, setEditable] = useState(false);
  const [currentStatus, setCurrentStatus] = useState('');
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [actionType, setActionType] = useState(''); // 'start', 'conclude' or 'cancel'
  const [isProcessingAction, setIsProcessingAction] = useState(false);

  const observationLength = watch('observation')?.length || 0;
  const status = watch('status');

  // Determina o passo ativo com base no status
  const activeStep = statusSteps.findIndex(step => step.value === status);

  useEffect(() => {
    const fetchRelocation = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        if (!user?.token) {
          throw new Error('Usuário não autenticado');
        }

        const response = await axios.get(
          buildApiUrl(`realocation/${id}`),
          {
            headers: {
              'Authorization': `Bearer ${user.token}`
            }
          }
        );

        const data = response.data;
        const isEditable = data.status === 'created' || data.status === 'in_progress';
        setEditable(isEditable);
        setCurrentStatus(data.status);

        const defaultValues = {
          titleRelocation: data.titleRelocation || '',
          status: data.status || '',
          cost: data.cost ? data.cost.toString() : '',
          originAddress: data.originAddress?.street || '',
          originCity: data.originAddress?.city || '',
          originNeighborhood: data.originAddress?.neighborhood || '',
          originState: data.originAddress?.state || '',
          destinationAddress: data.destinationAddress?.street || '',
          destinationCity: data.destinationAddress?.city || '',
          destinationNeighborhood: data.destinationAddress?.neighborhood || '',
          destinationState: data.destinationAddress?.state || '',
          propertyType: data.propertyType || '',
          category: data.category || '',
          petFriendly: data.petFriendly || false,
          observation: data.observation || '',
          startDate: data.startDate?.split('T')[0] || '',
          expectedEndDate: data.expectedEndDate?.split('T')[0] || ''
        };

        reset(defaultValues);

      } catch (error) {
        console.error('Erro ao carregar realocação:', error);
        let errorMessage = 'Erro ao carregar realocação';

        if (axios.isAxiosError(error)) {
          errorMessage = error.response?.data?.message || error.message;
        } else if (error instanceof Error) {
          errorMessage = error.message;
        }

        setSnackbarMessage(errorMessage);
        setSnackbarSeverity('error');
        setOpenSnackbar(true);
        navigate(-1);
      } finally {
        setIsLoading(false);
      }
    };

    fetchRelocation();
  }, [id, reset, navigate]);

  const updateStatus = async (newStatus) => {
    try {
      setIsProcessingAction(true);
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      if (!user?.token) {
        throw new Error('Usuário não autenticado');
      }

      const response = await axios.patch(
        buildApiUrl(`realocation/${id}/status`),
        { status: newStatus },
        {
          headers: {
            'Authorization': `Bearer ${user.token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.status >= 204) {
        setSnackbarMessage(`Status da realocação atualizado para "${statusSteps.find(s => s.value === newStatus).label}" com sucesso!`);
        setSnackbarSeverity('success');
        setOpenSnackbar(true);
        setCurrentStatus(newStatus);
        setValue('status', newStatus);
        
        // Se concluída ou cancelada, não é mais editável
        if (newStatus === 'concluded' || newStatus === 'canceled') {
          setEditable(false);
        }
        
        return true;
      } else {
        throw new Error('Erro ao atualizar status da realocação');
      }
    } catch (error) {
      console.error('Erro ao atualizar status:', error);
      let errorMessage = 'Erro ao atualizar status da realocação';

      if (axios.isAxiosError(error)) {
        errorMessage = error.response?.data?.message || error.message;
        if (error.response?.status === 400) {
          errorMessage = 'Dados inválidos: ' + (error.response.data.errors?.join(', ') || errorMessage);
        }
      } else if (error instanceof Error) {
        errorMessage = error.message;
      }

      setSnackbarMessage(errorMessage);
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
      return false;
    } finally {
      setIsProcessingAction(false);
      setOpenConfirmDialog(false);
    }
  };

  const handleStartRelocation = () => {
    setActionType('start');
    setOpenConfirmDialog(true);
  };

  const handleConcludeRelocation = () => {
    setActionType('conclude');
    setOpenConfirmDialog(true);
  };

  const handleCancelRelocation = () => {
    setActionType('cancel');
    setOpenConfirmDialog(true);
  };

const confirmStatusChange = async () => {
  let newStatus;
  if (actionType === 'start') {
    newStatus = 'in_progress'; // Corrigido para usar o mesmo formato
  } else if (actionType === 'conclude') {
    newStatus = 'concluded'; // Corrigido para usar o mesmo formato
  } else if (actionType === 'cancel') {
    newStatus = 'canceled'; // Corrigido para usar o mesmo formato
  }
  
  await updateStatus(newStatus);
};

  const onSubmit = async (data) => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      if (!user?.token) {
        throw new Error('Usuário não autenticado');
      }

      // Formatar o valor do custo
      const formattedCost = data.cost.includes(',') 
        ? parseFloat(data.cost.replace(/[^\d,]/g, '').replace(',', '.'))
        : parseFloat(data.cost);

      const payload = {
        titleRelocation: data.titleRelocation.trim(),
        cost: formattedCost,
        originAddress: {
          street: data.originAddress.trim(),
          city: data.originCity.trim(),
          neighborhood: data.originNeighborhood.trim(),
          state: data.originState.trim().toUpperCase(),
          country: 'Brasil'
        },
        destinationAddress: {
          street: data.destinationAddress.trim(),
          city: data.destinationCity.trim(),
          neighborhood: data.destinationNeighborhood.trim(),
          state: data.destinationState.trim().toUpperCase(),
          country: 'Brasil'
        },
        propertyType: data.propertyType,
        category: data.category,
        petFriendly: data.petFriendly,
        observation: data.observation?.trim() || null,
        startDate: data.startDate,
        expectedEndDate: data.expectedEndDate
      };

      const response = await axios.patch(
        buildApiUrl(`realocation/${id}`),
        payload,
        {
          headers: {
            'Authorization': `Bearer ${user.token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.status >= 204 && response.status < 300) {
        setSnackbarMessage('Realocação atualizada com sucesso!');
        setSnackbarSeverity('success');
        setOpenSnackbar(true);
        
        // Resetar o estado "dirty" do formulário
        reset(data, {
          keepValues: true,
          keepDirty: false
        });
      } else {
        throw new Error('Erro ao atualizar realocação');
      }
    } catch (error) {
      console.error('Erro ao atualizar realocação:', error);
      let errorMessage = 'Erro ao atualizar realocação';

      if (axios.isAxiosError(error)) {
        errorMessage = error.response?.data?.message || error.message;
        if (error.response?.status === 400) {
          errorMessage = 'Dados inválidos: ' + (error.response.data.errors?.join(', ') || errorMessage);
        }
      } else if (error instanceof Error) {
        errorMessage = error.message;
      }

      setSnackbarMessage(errorMessage);
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress size={60} />
      </Box>
    );
  }

  if (!editable && (currentStatus === '' || currentStatus === '')) {
    return (
      <Box sx={{ backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
        <AppBarComponent title="Edição de Realocação" />
        <Container maxWidth="lg" sx={{ py: 4 }}>
          <Paper elevation={0} sx={{ p: 4, borderRadius: 3, textAlign: 'center' }}>
            <Typography variant="h5" color="error" gutterBottom>
              Esta realocação já foi {currentStatus === 'concluded' ? 'concluída' : 'cancelada'}
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              {`Realocações com status "${currentStatus === 'concluded' ? 'CONCLUÍDA' : 'CANCELADA'}" não podem ser editadas.`}
            </Typography>
            <Button
              variant="contained"
              startIcon={<ArrowBackIcon />}
              onClick={() => navigate(-1)}
              sx={{ mt: 2 }}
            >
              Voltar
            </Button>
          </Paper>
        </Container>
      </Box>
    );
  }

  return (
    <Box sx={{ backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
      <AppBarComponent title="Edição de Realocação" />
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Paper elevation={0} sx={{ p: 4, borderRadius: 3 }}>
          <Box display="flex" alignItems="center" mb={2}>
            <FormTitle variant="h1">
              <SwapHorizIcon fontSize="large" />
              Editar Realocação
            </FormTitle>
          </Box>

          {/* Stepper de Status */}
          <StatusContainer>
            <Stepper
              alternativeLabel
              activeStep={activeStep}
              connector={<ColorlibConnector />}
            >
              {statusSteps.map((step, index) => (
                <Step key={step.label}>
                  <StepLabel
                    StepIconComponent={ColorlibStepIcon}
                    optional={
                      index <= activeStep ? (
                        <Typography variant="caption" color="text.secondary">
                          {index === 0 && 'Realocação criada'}
                          {index === 1 && 'Processo em andamento'}
                          {index === 2 && 'Realocação finalizada'}
                        </Typography>
                      ) : null
                    }
                  >
                    {step.label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          </StatusContainer>

          <Typography variant="body1" color="text.secondary" mb={4}>
            Edite os campos abaixo para atualizar esta realocação.
          </Typography>

          <Form onSubmit={handleSubmit(onSubmit)}>
            {/* Seção Informações Básicas */}
            <StyledFieldset>
              <SectionTitle variant="h2">
                <InfoIcon color="primary" />
                Informações Básicas
              </SectionTitle>

              <Row columns={1}>
                <Controller
                  name="titleRelocation"
                  control={control}
                  rules={{
                    required: 'Nome é obrigatório',
                    minLength: {
                      value: 3,
                      message: 'Nome deve ter pelo menos 3 caracteres'
                    }
                  }}
                  render={({ field, fieldState }) => (
                    <TextField
                      {...field}
                      label="Nome da Realocação *"
                      fullWidth
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                      InputLabelProps={{ shrink: true }}
                      placeholder="Ex: Mudança Família Silva"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <PersonIcon color={fieldState.error ? 'error' : 'action'} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
              </Row>

              <Row columns={3}>
                <EuroInput
                  control={control}
                  name="cost"
                  label="Custo em Euros *"
                  rules={{
                    required: 'Por favor, insira o valor estimado',
                    validate: value => {
                      const numericValue = parseFloat(value.replace(/[^\d,]/g, '').replace(',', '.'));
                      return numericValue >= 100 || 'O valor mínimo é € 100,00';
                    }
                  }}
                />

                <Controller
                  name="propertyType"
                  control={control}
                  rules={{ required: 'Tipo de imóvel é obrigatório' }}
                  render={({ field, fieldState }) => (
                    <TextField
                      {...field}
                      select
                      label="Tipo de Imóvel *"
                      fullWidth
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <ApartmentIcon color={fieldState.error ? 'error' : 'action'} />
                          </InputAdornment>
                        ),
                      }}
                    >
                      {propertyTypes.map((type) => (
                        <MenuItem key={type.value} value={type.value}>
                          {type.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                />

                <Controller
                  name="category"
                  control={control}
                  rules={{ required: 'Categoria é obrigatória' }}
                  render={({ field, fieldState }) => (
                    <TextField
                      {...field}
                      select
                      label="Categoria *"
                      fullWidth
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <CategoryIcon color={fieldState.error ? 'error' : 'action'} />
                          </InputAdornment>
                        ),
                      }}
                    >
                      {categories.map((cat) => (
                        <MenuItem key={cat.value} value={cat.value}>
                          {cat.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                />
              </Row>

              <Row columns={2}>
                <Controller
                  name="startDate"
                  control={control}
                  rules={{ required: 'Data de início é obrigatória' }}
                  render={({ field, fieldState }) => (
                    <TextField
                      {...field}
                      label="Data de Início *"
                      type="date"
                      fullWidth
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <CalendarIcon color={fieldState.error ? 'error' : 'action'} />
                          </InputAdornment>
                        ),
                        inputProps: {
                          max: watch('expectedEndDate') || '2100-12-31'
                        }
                      }}
                    />
                  )}
                />

                <Controller
                  name="expectedEndDate"
                  control={control}
                  rules={{
                    required: 'Data prevista de término é obrigatória',
                    validate: value =>
                      !watch('startDate') || value >= watch('startDate') ||
                      'Data deve ser posterior à data de início'
                  }}
                  render={({ field, fieldState }) => (
                    <TextField
                      {...field}
                      label="Data Prevista de Término *"
                      type="date"
                      fullWidth
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <CalendarIcon color={fieldState.error ? 'error' : 'action'} />
                          </InputAdornment>
                        ),
                        inputProps: {
                          min: watch('startDate') || '1900-01-01'
                        }
                      }}
                    />
                  )}
                />
              </Row>

              <Row columns={1}>
                <Controller
                  name="petFriendly"
                  control={control}
                  render={({ field }) => (
                    <FormControlLabel
                      control={
                        <Checkbox
                          {...field}
                          checked={field.value}
                          color="primary"
                          icon={<PetsIcon />}
                          checkedIcon={<PetsIcon color="primary" />}
                        />
                      }
                      label="Aceita animais de estimação"
                    />
                  )}
                />
              </Row>
            </StyledFieldset>

            {/* Seção Endereço de Origem */}
            <StyledFieldset>
              <SectionTitle variant="h2">
                <HomeIcon color="primary" />
                Endereço de Origem
              </SectionTitle>

              <Row columns={2}>
                <Controller
                  name="originAddress"
                  control={control}
                  rules={{
                    required: 'Endereço de origem é obrigatório',
                    minLength: {
                      value: 5,
                      message: 'Endereço deve ter pelo menos 5 caracteres'
                    }
                  }}
                  render={({ field, fieldState }) => (
                    <TextField
                      {...field}
                      label="Endereço de Origem *"
                      fullWidth
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                      InputLabelProps={{ shrink: true }}
                      placeholder="Ex: Av. Paulista, 1000"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <MapIcon color={fieldState.error ? 'error' : 'action'} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />

                <Controller
                  name="originNeighborhood"
                  control={control}
                  rules={{
                    required: 'Bairro de origem é obrigatório',
                    minLength: {
                      value: 3,
                      message: 'Bairro deve ter pelo menos 3 caracteres'
                    }
                  }}
                  render={({ field, fieldState }) => (
                    <TextField
                      {...field}
                      label="Bairro de Origem *"
                      fullWidth
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                      InputLabelProps={{ shrink: true }}
                      placeholder="Ex: Bela Vista"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <LocationCityIcon color={fieldState.error ? 'error' : 'action'} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
              </Row>

              <Row columns={3}>
                <Controller
                  name="originCity"
                  control={control}
                  rules={{
                    required: 'Cidade de origem é obrigatória',
                    minLength: {
                      value: 3,
                      message: 'Cidade deve ter pelo menos 3 caracteres'
                    }
                  }}
                  render={({ field, fieldState }) => (
                    <TextField
                      {...field}
                      label="Cidade de Origem *"
                      fullWidth
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                      InputLabelProps={{ shrink: true }}
                      placeholder="Ex: São Paulo"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <LocationCityIcon color={fieldState.error ? 'error' : 'action'} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />

                <Controller
                  name="originState"
                  control={control}
                  rules={{
                    required: 'Estado de origem é obrigatório',
                    minLength: {
                      value: 2,
                      message: 'Estado deve ter 2 caracteres'
                    },
                    maxLength: {
                      value: 2,
                      message: 'Estado deve ter 2 caracteres'
                    }
                  }}
                  render={({ field, fieldState }) => (
                    <TextField
                      {...field}
                      label="Estado (UF) de Origem *"
                      fullWidth
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message || 'Ex: SP'}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        maxLength: 2,
                        style: { textTransform: 'uppercase' }
                      }}
                      placeholder="SP"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <MapIcon color={fieldState.error ? 'error' : 'action'} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
              </Row>
            </StyledFieldset>

            {/* Seção Endereço de Destino */}
            <StyledFieldset>
              <SectionTitle variant="h2">
                <HomeIcon color="primary" />
                Endereço de Destino
              </SectionTitle>

              <Row columns={2}>
                <Controller
                  name="destinationAddress"
                  control={control}
                  rules={{
                    required: 'Endereço de destino é obrigatório',
                    minLength: {
                      value: 5,
                      message: 'Endereço deve ter pelo menos 5 caracteres'
                    }
                  }}
                  render={({ field, fieldState }) => (
                    <TextField
                      {...field}
                      label="Endereço de Destino *"
                      fullWidth
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                      InputLabelProps={{ shrink: true }}
                      placeholder="Ex: Rua Oscar Freire, 500"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <MapIcon color={fieldState.error ? 'error' : 'action'} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />

                <Controller
                  name="destinationNeighborhood"
                  control={control}
                  rules={{
                    required: 'Bairro de destino é obrigatório',
                    minLength: {
                      value: 3,
                      message: 'Bairro deve ter pelo menos 3 caracteres'
                    }
                  }}
                  render={({ field, fieldState }) => (
                    <TextField
                      {...field}
                      label="Bairro de Destino *"
                      fullWidth
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                      InputLabelProps={{ shrink: true }}
                      placeholder="Ex: Jardins"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <LocationCityIcon color={fieldState.error ? 'error' : 'action'} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
              </Row>

              <Row columns={3}>
                <Controller
                  name="destinationCity"
                  control={control}
                  rules={{
                    required: 'Cidade de destino é obrigatória',
                    minLength: {
                      value: 3,
                      message: 'Cidade deve ter pelo menos 3 caracteres'
                    }
                  }}
                  render={({ field, fieldState }) => (
                    <TextField
                      {...field}
                      label="Cidade de Destino *"
                      fullWidth
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                      InputLabelProps={{ shrink: true }}
                      placeholder="Ex: São Paulo"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <LocationCityIcon color={fieldState.error ? 'error' : 'action'} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />

                <Controller
                  name="destinationState"
                  control={control}
                  rules={{
                    required: 'Estado de destino é obrigatório',
                    minLength: {
                      value: 2,
                      message: 'Estado deve ter 2 caracteres'
                    },
                    maxLength: {
                      value: 2,
                      message: 'Estado deve ter 2 caracteres'
                    }
                  }}
                  render={({ field, fieldState }) => (
                    <TextField
                      {...field}
                      label="Estado (UF) de Destino *"
                      fullWidth
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message || 'Ex: SP'}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        maxLength: 2,
                        style: { textTransform: 'uppercase' }
                      }}
                      placeholder="SP"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <MapIcon color={fieldState.error ? 'error' : 'action'} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
              </Row>
            </StyledFieldset>

            {/* Seção Observações */}
            <StyledFieldset>
              <SectionTitle variant="h2">
                <NotesIcon color="primary" />
                Observações
                <Tooltip title="Informações adicionais sobre a realocação">
                  <IconButton size="small" sx={{ ml: 1 }}>
                    <InfoIcon fontSize="small" color="info" />
                  </IconButton>
                </Tooltip>
              </SectionTitle>

              <Row columns={1}>
                <Controller
                  name="observation"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label="Observações Adicionais"
                      multiline
                      rows={4}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        maxLength: 500
                      }}
                      placeholder="Detalhes importantes sobre a realocação (opcional)"
                      helperText={`${observationLength}/500 caracteres`}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start" sx={{ alignSelf: 'flex-start', mt: 1 }}>
                            <NotesIcon color="action" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
              </Row>
            </StyledFieldset>

            {/* Botões de Ação */}
            <ButtonAreaStyled>
              <Stack direction="row" spacing={2} sx={{ mr: 'auto' }}>
                {status === 'created' && (
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<PlayCircleIcon />}
                    onClick={handleStartRelocation}
                    disabled={isProcessingAction}
                  >
                    Iniciar Realocação
                  </Button>
                )}
                
                {(status === 'created' || status === 'in_progress') && (
                  <Button
                    variant="contained"
                    color="success"
                    startIcon={<CheckCircleIcon />}
                    onClick={handleConcludeRelocation}
                    disabled={isProcessingAction}
                  >
                    Concluir Realocação
                  </Button>
                )}

                {(status === 'created' || status === 'in_progress') && (
                  <Button
                    variant="contained"
                    color="error"
                    startIcon={<CancelIcon />}
                    onClick={handleCancelRelocation}
                    disabled={isProcessingAction}
                  >
                    Cancelar Realocação
                  </Button>
                )}
              </Stack>

              <Button
                type="button"
                variant="outlined"
                onClick={() => navigate(-1)}
                disabled={isSubmitting || isProcessingAction}
                sx={{
                  minWidth: 120,
                  px: 3,
                  py: 1,
                  borderRadius: 2
                }}
              >
                Voltar
              </Button>

              <Button
                type="submit"
                variant="contained"
                size="large"
                disabled={isSubmitting || !isValid || !isDirty || isProcessingAction}
                sx={{
                  minWidth: 200,
                  px: 4,
                  py: 1.5,
                  borderRadius: 2,
                  fontWeight: 600,
                  '&:hover': {
                    backgroundColor: '#1565c0'
                  }
                }}
              >
                {isSubmitting ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  'Salvar Alterações'
                )}
              </Button>
            </ButtonAreaStyled>
          </Form>
        </Paper>

        {/* Snackbar para feedback */}
        <Snackbar
          open={openSnackbar}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert
            elevation={6}
            variant="filled"
            severity={snackbarSeverity}
            onClose={handleCloseSnackbar}
            sx={{ width: '100%', borderRadius: 2 }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>

        {/* Diálogo de confirmação */}
        <Dialog
          open={openConfirmDialog}
          onClose={() => setOpenConfirmDialog(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {actionType === 'start' 
              ? 'Iniciar Realocação' 
              : actionType === 'conclude' 
                ? 'Concluir Realocação' 
                : 'Cancelar Realocação'}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {actionType === 'start' 
                ? 'Tem certeza que deseja iniciar esta realocação? Esta ação não pode ser desfeita.'
                : actionType === 'conclude' 
                  ? 'Tem certeza que deseja concluir esta realocação? Esta ação não pode ser desfeita.'
                  : 'Tem certeza que deseja cancelar esta realocação? Esta ação não pode ser desfeita.'}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button 
              onClick={() => setOpenConfirmDialog(false)} 
              disabled={isProcessingAction}
            >
              Cancelar
            </Button>
            <Button 
              onClick={confirmStatusChange} 
              color={
                actionType === 'start' 
                  ? 'primary' 
                  : actionType === 'conclude' 
                    ? 'success' 
                    : 'error'
              }
              autoFocus
              disabled={isProcessingAction}
              startIcon={isProcessingAction ? <CircularProgress size={20} /> : null}
            >
              {isProcessingAction 
                ? 'Processando...' 
                : actionType === 'start' 
                  ? 'Iniciar' 
                  : actionType === 'conclude'
                    ? 'Concluir'
                    : 'Cancelar'}
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Box>
  );
}